import type { Location } from 'history'
import qs from 'qs'

/**
 * Free-text params that must come back exactly as written. `setUrlQuery` patches `qs.parse` with
 * qs-numbers, which parseFloats any numeric-looking value: `?search=3885` would come back as the
 * number 3885 (rejected by `$query: String!`), and `0123` as 123. `search` is used by every search
 * bar; `q` by the admin sidebar search.
 */
const TEXT_PARAMS = ['search', 'q']

/**
 * When React hooks ship to production, we can replace this
 */
export function getUrlQuery<T>(_: { location: Location<any> }) {
  const parsed = qs.parse(decodeURI(location.search.substring(1, location.search.length)), {
    arrayLimit: 1000
  }) as Record<string, unknown>

  const raw = new URLSearchParams(location.search)
  for (const key of TEXT_PARAMS) {
    const value = raw.get(key)
    if (value !== null) {
      parsed[key] = value
    }
  }

  return parsed as unknown as T
}
